import moment from 'moment';
import { getCurrentDate } from '../../utils/DateUtils';

export const PENDING_AGE_OPTIONS = [7, 28];
export const PENDING_DEFAULT_LOOKBACK_DAYS = 90;
export const CUBE_ID_COLUMN_MIN_WIDTH = '220px';
export const CUBE_ID_DISPLAY_STYLE = {
  width: '100%',
  minWidth: CUBE_ID_COLUMN_MIN_WIDTH,
  backgroundColor: 'white',
  cursor: 'not-allowed',
  textAlign: 'center',
  boxSizing: 'border-box',
  overflow: 'visible',
  fontSize: '0.92rem',
  paddingLeft: '6px',
  paddingRight: '6px',
};
export const CUBE_ID_CELL_STYLE = {
  minWidth: CUBE_ID_COLUMN_MIN_WIDTH,
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
};

export function mapAllowedPlants(plantList) {
  return (plantList?.plant_list || [])
    .filter((plant) => plant.status)
    .map((plant) => ({
      value: plant.id,
      label: plant.plant_alias,
    }));
}

export function pickDefaultPlantId(plantOptions) {
  return plantOptions?.[0]?.value || '';
}

export function getDefaultDcPeriod() {
  const today = moment();
  return {
    fromDate: today.clone().subtract(PENDING_DEFAULT_LOOKBACK_DAYS, 'days'),
    uptoDate: today.clone(),
  };
}

export function resolvePendingQueryRange(ageDays, fromDate, uptoDate) {
  const today = moment();
  const latestDue = today.clone().subtract(ageDays, 'days');

  let queryUpto = uptoDate.clone();
  if (!queryUpto.isValid()) {
    queryUpto = latestDue.clone();
  }
  if (queryUpto.isAfter(latestDue, 'day')) {
    queryUpto = latestDue.clone();
  }

  let queryFrom = fromDate.clone();
  if (!queryFrom.isValid()) {
    queryFrom = getDefaultDcPeriod().fromDate;
  }
  if (queryFrom.isAfter(queryUpto, 'day')) {
    queryFrom = queryUpto.clone();
  }

  return { fromDate: queryFrom, uptoDate: queryUpto };
}

export function getPendingQueryRange(ageDays) {
  const { fromDate, uptoDate } = getDefaultDcPeriod();
  return resolvePendingQueryRange(ageDays, fromDate, uptoDate);
}

export function formatPendingRangeLabel(fromDate, uptoDate) {
  return `${fromDate.format('DD-MM-YYYY')} → ${uptoDate.format('DD-MM-YYYY')}`;
}

export function buildPendingListTitle(ageDays, fromDate, uptoDate) {
  return `${ageDays} Days Pending — Casting ${formatPendingRangeLabel(fromDate, uptoDate)}`;
}

export function getInitialCubeTestReportFormState() {
  return {
    csr_date: getCurrentDate(),
    plant_id: '',
    casting_dt: '',
    cured_place: '',
    cement_type: '',
    cement_content: '',
    technician_name: '',
    no_of_moulds: 0,
    user_remarks: '',
    csr_no: '',
    prefix: '',
    csr_num_prefix: '',
    pending_age_days: '',
  };
}

export function buildReportNumberDisplay(prefix, reportNo) {
  if (!prefix && !reportNo) {
    return '';
  }
  return `${prefix || ''}${reportNo || ''}`;
}

export function mapPendingListRecords(records) {
  return (records || []).map((item, index) => ({
    ...item,
    id: item.id || index + 1,
  }));
}

export function getPendingColumns(includeStatus = true) {
  const columns = [
    { fieldName: 'id', headerName: 'ROW_ACTIONS', size: 40 },
    { fieldName: 'delivery_challan_date', headerName: 'Casting Date', size: 50 },
    { fieldName: 'customer_name', headerName: 'Customer', size: 180 },
    { fieldName: 'project_name', headerName: 'Site', size: 180 },
    { fieldName: 'product_name', headerName: 'Grade', size: 50 },
    { fieldName: 'total_dc_qty', headerName: 'Dc Qty', size: 50 },
  ];
  if (includeStatus) {
    columns.splice(1, 0, { fieldName: 'pending_status', headerName: 'Status', size: 60 });
  }
  return columns;
}

export function decoratePendingRecords(records) {
  return mapPendingListRecords(records).map((item) => ({
    ...item,
    pending_status: item.pending_type === 'update'
      ? `Update${item.report_no ? ` (${item.report_no})` : ''}`
      : (item.suggest_close ? 'New (Close OK)' : 'New'),
  }));
}
